<template>
  <!-- my profile screen, shows the data of the logged in user and possible edits -->

  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="changePasswordModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="text-center text-join">Alterar senha</h5>

          <button
            type="button"
            class="close"
            id="closeChangePasswordModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form
            class="form-signin"
            autocomplete="off"
            @submit.prevent="accessChangePassword"
          >
            <label for="currentChangePassword label-config">Senha atual</label>
            <div class="input-group mb-2 edit-input">
              <input
                type="password"
                id="currentChangePassword"
                class="form-control input-length"
                v-bind:class="{ 'is-invalid': errors.current_password }"
                placeholder="Digite sua senha atual"
                required
                autofocus
                v-model="currentPassword"
              />
            </div>
            <span v-if="errors.current_password" class="error">
              <ul>
                <li v-for="msg in errors.current_password">{{ msg }}</li>
              </ul>
            </span>

            <label for="confirmNewChangePassword label-config"
              >Nova senha</label
            >

            <div class="input-group mb-2 edit-input">
              <input
                type="password"
                id="newChangePassword"
                class="form-control input-length"
                v-bind:class="{ 'is-invalid': errors.new_password }"
                placeholder="Digite uma nova senha"
                required
                autofocus
                v-model="newPassword"
              />
            </div>
            <span v-if="errors.new_password" class="error">
              <ul>
                <li v-for="msg in errors.new_password">{{ msg }}</li>
              </ul>
            </span>

            <label for="newChangePassword label-config">Repetir senha</label>

            <div class="input-group edit-input">
              <input
                type="password"
                id="confirmNewChangePassword"
                class="form-control input-length"
                v-bind:class="{
                  'is-invalid': errors.new_password,
                }"
                placeholder="Repita sua nova senha"
                required
                autofocus
                v-model="newPasswordConfirmation"
              />
            </div>
            <div class="input-group mb-3 edit-input">
              <p class="text-align-center">
                A senha deve conter no mínimo 8(oito) caracteres, contendo
                letras, números e símbolos. O sistema diferencia letras
                maiúsculas de minúsculas.
              </p>
            </div>

            <div class="access-center">
              <button
                class="btn btn-lg access"
                id="sendChangePassword"
                type="submit"
              >
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "ChangePassword",
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      newPasswordConfirmation: "",
      errors: [],
    };
  },

  methods: {
    accessChangePassword: function () {
      let data = {
        current_password: this.currentPassword,
        new_password: this.newPassword,
        new_password_confirmation: this.newPasswordConfirmation,
      };
      this.errors = [];
      axios
        .put(`${process.env.API_PBM}/user/password`, this.$qs.stringify(data))
        .then((response) => {
          $("#changePasswordModal").modal("hide");

          Vue.$toast.success("Senha alterada com sucesso!", {
            position: "top-right",
            duration: 5000,
          });
        })

        .catch((error) => {
          this.errors = error.response.data.message;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 35%;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control {
  color: gray;
}

.input-length {
  margin: 0 auto;
}

.edit-button {
  background-color: #ced4da;
  height: 100%;
  border: none;
  border-radius: 2px;
}
label {
  display: inline-block;
  font-size: 17px;
  color: rgb(100, 95, 95);
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
  width: 100%;
  margin-left: -20px;
}
.text-align-center {
  color: rgb(100, 95, 95);
  font-size: 14px;
}

.access {
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
}
.access-center {
  text-align: center;
}

@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 31%;
  }

  .text-align-center {
    margin-top: 5px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }

  .modal {
    padding: 0px !important;
  }
}
@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
  .modal-dialog {
    margin-top: 4%;
  }
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
  .modal-dialog {
    margin-top: 20%;
  }
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
  .modal-dialog {
    margin-top: 30%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/changePassword/ChangePassword.vue